((Drupal, $) => {

  const showSuccess = (modal) => {
    const form = modal.querySelector('.ouigo-newsletter-modal__form');
    const titleEl = modal.querySelector('.ouigo-newsletter-modal__title');
    const descEl = modal.querySelector('.ouigo-newsletter-modal__description');
    const successEl = modal.querySelector('.ouigo-newsletter-modal__success-message');
    const errorEl = modal.querySelector('.ouigo-newsletter-modal__error-message');

    if (form) form.classList.add('d-none');
    if (titleEl) titleEl.classList.add('d-none');
    if (descEl) descEl.classList.add('d-none');
    if (errorEl) errorEl.classList.add('d-none');

    if (successEl) {
      successEl.classList.remove('d-none');
      const successTitle = successEl.querySelector('h3');
      if (successTitle) {
        successTitle.setAttribute('tabindex', '-1');
        successTitle.focus();
      }
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'generate_lead',
      form_subject: 'newsletter',
    });
  };

  const showError = (modal) => {
    const form = modal.querySelector('.ouigo-newsletter-modal__form');
    const titleEl = modal.querySelector('.ouigo-newsletter-modal__title');
    const descEl = modal.querySelector('.ouigo-newsletter-modal__description');
    const successEl = modal.querySelector('.ouigo-newsletter-modal__success-message');
    const errorEl = modal.querySelector('.ouigo-newsletter-modal__error-message');

    if (form) form.classList.add('d-none');
    if (titleEl) titleEl.classList.add('d-none');
    if (descEl) descEl.classList.add('d-none');
    if (successEl) successEl.classList.add('d-none');

    if (errorEl) {
      errorEl.classList.remove('d-none');
      const errorTitle = errorEl.querySelector('h3');
      if (errorTitle) {
        errorTitle.setAttribute('tabindex', '-1');
        errorTitle.focus();
      }
    }
  };


  const DIGIT_PATTERN = /\p{Nd}/u;

  const getFieldError = (input) => {
    const { dataset } = input;
    const value = input.value.trim();

    if (!value) return dataset.errorRequired || '';
    if (dataset.minLength && [...value].length < Number(dataset.minLength)) return dataset.errorMinLength || '';
    if (dataset.noDigits === 'true' && DIGIT_PATTERN.test(value)) return dataset.errorDigits || '';
    if (input.type === 'email' && input.validity.typeMismatch) return dataset.errorInvalid || '';
    return '';
  };

  const getFeedbackEl = (input) => {
    const feedbackId = `${input.id}--error`;
    let feedback = document.getElementById(feedbackId);
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.id = feedbackId;
      feedback.className = 'ouigo-newsletter-modal__feedback';
      feedback.hidden = true;
      input.insertAdjacentElement('afterend', feedback);
    }
    return feedback;
  };

  const setFieldError = (input, message) => {
    const feedback = getFeedbackEl(input);
    const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));

    input.classList.toggle('is-invalid', Boolean(message));
    feedback.textContent = message;
    feedback.hidden = !message;

    if (message) {
      input.setAttribute('aria-invalid', 'true');
      describedBy.add(feedback.id);
    } else {
      input.removeAttribute('aria-invalid');
      describedBy.delete(feedback.id);
    }

    if (describedBy.size) {
      input.setAttribute('aria-describedby', [...describedBy].join(' '));
    } else {
      input.removeAttribute('aria-describedby');
    }
  };

  const showFieldErrors = (modal, errors) => {
    const form = modal.querySelector('.ouigo-newsletter-modal__form');
    if (!form) return;

    let firstInvalid = null;
    for (const input of form.querySelectorAll('.ouigo-newsletter-modal__input')) {
      const message = (errors && errors[input.name]) || '';
      setFieldError(input, message);
      if (message && !firstInvalid) firstInvalid = input;
    }
    if (firstInvalid) firstInvalid.focus();
  };

  if ($ && $.fn) {
    $.fn.showNewsletterFieldErrors = function (errors) {
      return this.each(function () {
        showFieldErrors(this, errors);
      });
    };

    $.fn.showNewsletterSuccess = function () {
      return this.each(function () {
        showSuccess(this);
      });
    };

    $.fn.showNewsletterError = function () {
      return this.each(function () {
        showError(this);
      });
    };
  }

  Drupal.behaviors.ouigoNewsletterModal = {
    attach: (context) => {
      const modal = context.querySelector ? context.querySelector('#newsletter-modal-global') : null;

      if (!modal || modal.hasAttribute('data-newsletter-bound')) return;
      modal.setAttribute('data-newsletter-bound', 'true');

      const form = modal.querySelector('.ouigo-newsletter-modal__form');
      const titleEl = modal.querySelector('.ouigo-newsletter-modal__title');
      const descEl = modal.querySelector('.ouigo-newsletter-modal__description');
      const successEl = modal.querySelector('.ouigo-newsletter-modal__success-message');
      const errorEl = modal.querySelector('.ouigo-newsletter-modal__error-message');
      const inputs = form ? form.querySelectorAll('.ouigo-newsletter-modal__input') : [];
      const closeBtns = modal.querySelectorAll('.ouigo-newsletter-modal__close-btn, .ouigo-newsletter-modal__close-cta');

      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', () => {
          if (window.bootstrap && window.bootstrap.Modal) {
            const instance = window.bootstrap.Modal.getInstance(modal) || new window.bootstrap.Modal(modal);
            instance.hide();
          } else if (window.jQuery) {
            window.jQuery(modal).modal('hide');
          }
        });
      });

      // Turnstile tokens are single-use: once a submission consumed one, the
      // widget must issue a fresh challenge or the next submission fails
      // server-side with "The response parameter has already been validated
      // before". Safe to call when the Cloudflare script is not loaded.
      const resetTurnstile = () => {
        const widget = form ? form.querySelector('.cf-turnstile') : null;
        if (widget && window.turnstile && typeof window.turnstile.reset === 'function') {
          window.turnstile.reset(widget);
        }
      };

      if (form) {
        for (const input of inputs) {
          input.addEventListener('input', () => {
            if (input.classList.contains('is-invalid')) {
              setFieldError(input, getFieldError(input));
            }
          });
        }

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopPropagation();

          let firstInvalid = null;
          for (const input of inputs) {
            const message = getFieldError(input);
            setFieldError(input, message);
            if (message && !firstInvalid) firstInvalid = input;
          }

          if (firstInvalid) {
            firstInvalid.focus();
            return;
          }

          if (form.hasAttribute('data-newsletter-submitting')) return;

          const submitBtn = form.querySelector('.ouigo-newsletter-modal__submit-btn');
          form.setAttribute('data-newsletter-submitting', 'true');
          if (submitBtn) submitBtn.disabled = true;


          const url = new URL(form.getAttribute('action') || window.location.href, window.location.href);
          url.searchParams.set('ajax_form', '1');

          fetch(url, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: { Accept: 'application/vnd.drupal-ajax' },
          })
            .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
            .then((commands) => {
              const invoked = (method) =>
                Array.isArray(commands) && commands.find((c) => c.command === 'invoke' && c.method === method);

              const fieldErrors = invoked('showNewsletterFieldErrors');
              if (fieldErrors) {
                showFieldErrors(modal, fieldErrors.args?.[0]);
              } else if (invoked('showNewsletterSuccess')) {
                showSuccess(modal);
              } else {
                showError(modal);
              }
            })
            .catch(() => showError(modal))
            .finally(() => {
              form.removeAttribute('data-newsletter-submitting');
              if (submitBtn) submitBtn.disabled = false;
              // The token sent by this submission is consumed — issue a
              // fresh challenge for any subsequent submission.
              resetTurnstile();
            });
        });
      }

      modal.addEventListener('hidden.bs.modal', () => {
        if (form) {
          form.reset();
          for (const input of inputs) setFieldError(input, '');
          form.classList.remove('d-none');
        }
        resetTurnstile();
        if (titleEl) titleEl.classList.remove('d-none');
        if (descEl) descEl.classList.remove('d-none');
        if (successEl) successEl.classList.add('d-none');
        if (errorEl) errorEl.classList.add('d-none');
      });
    },
  };
})(Drupal, window.jQuery);
